module.exports = __webpack_public_path__ + "static/media/2020.12.03卫生院助力艾滋病讲座.f1e2c930.jpg";